export const getRegistrantCodeOptions = (registrantCode, students) => {
    return students.reduce((data, student) => {
        if (
            student.registrantCode !== registrantCode &&
            student.participatingUniversities.some(
                (university) => university.must_visit
            )
        ) {
            data.push({
                name: student.name,
                registrantCode: student.registrantCode,
            });
        }

        return data;
    }, []);
};

export const getUniversitiesFromStudent = (selectedStudent, students) => {
    const student = students.find(
        (student) => student.registrantCode === selectedStudent.registrantCode
    );

    if (!student) return [];

    return (student.participatingUniversities || []).filter(
        (university) => university.must_visit
    );
};
